import { MenuItem } from "@mui/material";
import { buildClass, checkClass } from "@utils/tag";

const Option = ({ innerRef, isSelected, isFocused, innerProps, children }) => {
  return (
    <MenuItem
      ref={innerRef}
      selected={isFocused}
      component="div"
      className={buildClass(
        "!text-[12px] sm:!text-[16px] !px-5 !py-3",
        "hover:!bg-[#0366ff14] !text-[#333] cursor-pointer",
        checkClass(isSelected, [
          "!bg-[#0366ff14] font-medium font-Expo_sim",
          "font-normal font-Expo_bok",
        ])
      )}
      {...innerProps}
    >
      {children}
    </MenuItem>
  );
};

export default Option;
